import { Typography } from "@mui/material";
import React from "react";

export default function Span({ text, ...rest }) {
  return (
    <Typography component={"span"} {...rest}>
      {text}
    </Typography>
  );
}
